import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';

import async from '@xanadu/ui-shared/components/asyncComponent';

const AsyncEventsNew = async(() =>
  import('@xanadu/ui-shared/components/GlobalEventsPage').then(module => module.default)
);

const AsyncSingleEvent = async(() =>
  import('@xanadu/ui-shared/components/SingleEventPage').then(module => module.default)
);

let segments = [];

function RouteHandler({
  location: { pathname },
}) {
  const tagsSegment = pathname.split('/events/');
  const splat = tagsSegment[1] || '';

  // remove duplicate slashes and turn into array of path segments and drop empty segments
  const nextSegments = splat.replace(/(\/)+/g, '$1').split('/').filter(x => !!x);

  if (
    segments.length !== nextSegments.length
    || !nextSegments.every((segment, i) => segment === segments[i])
  ) {
    segments = nextSegments;
  }

  const eventId = segments.filter(segment => /^[0-9]+$/.test(segment)).pop();

  if (eventId) {
    return (<AsyncSingleEvent id={eventId} />);
  }

  if (!segments.length) {
    return <Redirect to="/" />;
  }

  return (
    <React.Fragment>
      <AsyncEventsNew
        showOptions
        setMetadata
        segments={segments}
        withQuickLinks={false}
      />
    </React.Fragment>
  );
}

RouteHandler.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
};

export default withRouter(RouteHandler);
